export default __webpack_public_path__ + "static/media/after-effects.6f1cc988.gif";